exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-windows-container[data-v-26590722]{padding:20px}.popup-windows-container[data-v-26590722]  .el-tabs .el-tabs__header{margin-bottom:20px}.popup-windows-container[data-v-26590722]  .el-tabs .el-tabs__content .el-tab-pane{padding:0}.popup-windows-container .dynamic-tab-content[data-v-26590722]{padding:20px;text-align:center;color:#909399;font-size:14px;min-height:200px;background-color:#f8f9fa;border-radius:4px;border:1px dashed #dcdfe6;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
